module.exports = __webpack_public_path__ + "static/media/logo-black.9954607c.svg";